import markup from './service-cards.component.html?raw';
import styles from './service-cards.component.scss?inline';

const template = document.createElement('template');
template.innerHTML = `
  <style>${styles}</style>
  ${markup}
`;

class ServiceCardsElement extends HTMLElement {
  public constructor() {
    super();

    const root = this.attachShadow({ mode: 'open' });
    root.appendChild(template.content.cloneNode(true));
  }
}

if (!customElements.get('service-cards')) {
  customElements.define('service-cards', ServiceCardsElement);
}
